const CONTEXTUAL_BACK_NONCE = '__deepmoxContextualBackNonce';

export type ContextualBackDecision = { kind: 'history-back' } | { kind: 'fallback' };

export interface ContextualBackNavigation {
	markChildEntry(state?: Record<string, unknown>): Record<string, unknown>;
	backDecision(state: unknown): ContextualBackDecision;
}

function createRuntimeNonce(): string {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
	return `contextual-back-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/**
 * The nonce lives only in this JS runtime. A browser can restore history.state
 * after refresh, but it cannot restore this nonce, so a refreshed child route
 * always uses its safe canonical fallback instead of leaving the product.
 */
export function createContextualBackNavigation(nonce = createRuntimeNonce()): ContextualBackNavigation {
	return {
		markChildEntry(state = {}) {
			return { ...state, [CONTEXTUAL_BACK_NONCE]: nonce };
		},
		backDecision(state) {
			if (state && typeof state === 'object' && (state as Record<string, unknown>)[CONTEXTUAL_BACK_NONCE] === nonce) {
				return { kind: 'history-back' };
			}
			return { kind: 'fallback' };
		},
	};
}

export const contextualBackNavigation = createContextualBackNavigation();
